const TENANT_STORAGE_KEY = 'portal:activeTenant';

interface TenantUpdate {
  tenantId: string | undefined;
  timestamp: number;
  source: string;
}

export const tenantStorage = {
  // Update tenant and notify other tabs
  updateTenant: (tenantId: string | undefined) => {
    const update: TenantUpdate = {
      tenantId,
      timestamp: Date.now(),
      source: crypto.randomUUID() // Unique ID for this tab
    };
    localStorage.setItem(TENANT_STORAGE_KEY, JSON.stringify(update));
  },

  // Get current tenant from storage
  getCurrentTenant: (): TenantUpdate | null => {
    const stored = localStorage.getItem(TENANT_STORAGE_KEY);
    if (!stored) return null;
    
    try {
      return JSON.parse(stored) as TenantUpdate;
    } catch {
      return null;
    }
  },

  // Listen for tenant changes
  onTenantChange: (callback: (update: TenantUpdate) => void) => {
    const handleStorage = (event: StorageEvent) => {
      if (event.key !== TENANT_STORAGE_KEY || !event.newValue) return;
      
      try {
        const update = JSON.parse(event.newValue) as TenantUpdate;
        callback(update);
      } catch (_error) {
        console.error('Failed to parse tenant update:', _error);
      }
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }
};
